<template lang="pug">
  .component-driver-subscription-slots
    .row
      .columns.driver-slot.small-2(v-for="(slot, index) in availableSlots")
        .inner-content
          dropdown
            img.driver-image(slot="placeholder", :src='slot.profile_picture')
            .unselect(v-if="slot.available")
              .row
                .columns.small-9
                  selectize-driver(v-if="selectizeDrivers", :clientDrivers="selectizeDrivers", @optionSelected="setDriverId")
                .columns.small-2
                  input.button.small(type='submit', value='Add', v-on:click="addDriver(index)")

            .select(v-else="")
              a(v-on:click="removeDriver(index)") Remove from subscription
          | {{slot.name}} {{slot.surname}}


</template>
<script type="text/babel">
  import Dropdown from "../foundation/Dropdown";
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import MaggieHelper from "src/maggieHelper";
  import SelectizeDriver from "./lists/selectize/SelectizeDriver";

  export default {
    name: "DriverSubscriptionSlots",
    components: {
      SelectizeDriver,
      Dropdown,
      KeplerBackofficeSdk
    },
    data() {
      return {
        selectizeDrivers: null,

        placeholderImg: 'https://cdn4.iconfinder.com/data/icons/wirecons-free-vector-icons/32/add-128.png',
        availableSlots: [],
        availableDrivers: [],


        selectableDrivers: [],
        selectedDriver: null
      }
    },
    created() {
      this.setSlots(this.subscribedDrivers);
      KeplerBackofficeSdk.clients.list(1, 10000, {id: this.clientId}).drivers((items) => {
        this.selectizeDrivers = items.items
        items.items.forEach((driver) => {
          this.availableDrivers.push(driver)
        })

      })
    },
    methods: {
      setDriverId(driver) {
        this.selectedDriver = driver.id
      },
      removeDriver(index) {
        this.$confirm('Are you sure?', 'Do you really want to remove this driver?', () => {

          var available = this.availableSlots[index];

          KeplerBackofficeSdk.subscriptions.select(this.subscriptionId, {driver_id: available.id}).removeDriver((response) => {
            this.availableDrivers.push(available);

            this.availableSlots.splice(index, 1, {
              name: '',
              surname: '',
              available: true,
              profile_picture: this.placeholderImg,
            });
            MaggieHelper.notification('remove-driver', response)
          })
        })

      },
      addDriver(slot) {
        this.availableDrivers.forEach((item, a) => {
          if (item.id == this.selectedDriver) {
            this.availableSlots.splice(slot, 1, item);
            this.availableDrivers.splice(a, 1)
          }
        });

        KeplerBackofficeSdk.subscriptions.select(this.subscriptionId, {driver_id: this.selectedDriver}).addDriver(() => {
          MaggieHelper.notification('add-driver', 'Driver added to subscription')
        })
      },
      setSlots(drivers) {
        var slotsLength = this.subscribedDrivers.length < this.maxDrivers ? this.subscribedDrivers.length + 1 : this.subscribedDrivers.length;
        drivers.forEach((item) => {
          item.available = false;
          this.availableSlots.push(item)
        });

        if (slotsLength > this.availableSlots.length) {
          this.availableSlots.push({
            name: '',
            surname: '',
            available: true,
            profile_picture: this.placeholderImg,
          })
        }
      },

    },
    props: ['subscriptionId', 'maxDrivers', 'subscribedDrivers', 'clientId']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  //.component-driver-subscription-slots span

      display: inline !important
      margin-left: 20px
      margin-right: 20px


</style>



// WEBPACK FOOTER //
// DriverSubscriptionSlots.vue?4fd289d6